import { selectors as commonSelectors } from '~/domains/common';
import { selectors as featureFlagsSelectors } from '~/domains/featureFlags';
import { REUSE_METRICS_ENABLED } from '~/domains/featureFlags/keys';
import { isLoggedIn } from '~/utils/validations/profile';

const resolve = async ({ getState }) => {
  const state = getState();
  const profile = commonSelectors.profile(state);
  const isReuseMetricsEnabled = featureFlagsSelectors.featureFlag(
    state,
    REUSE_METRICS_ENABLED
  );

  isLoggedIn(profile);

  if (!isReuseMetricsEnabled) {
    const error = new Error('Page not enabled');

    error.status = 404;

    throw error;
  }
};

export default resolve;
